import * as React from 'react';
import CardSection from '../../common/CardSection';

import Office from '../../../models/Office';
import FormSelect from '../../controls/forms/redesign/FormFilterSelect';
import FormRow from '../../controls/forms/FormRow';
import { SelectItem } from 'src/models/common/SelectItem';
import State from '../../../models/State';
import { ODataOptions } from 'src/util/ODataBuilder';
import PagedResultSet from 'src/models/common/PagedResultSet';

import { connect } from 'react-redux';
import { replace } from 'connected-react-router';

import actions from 'src/actions';
import { IRootState } from 'src/reducers';
import Form from 'src/components/controls/forms/Form';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import { RouteComponentProps } from 'react-router';
import { AnyObject } from 'final-form';
import selectors from 'src/selectors';

interface IAdminEditOfficePageStoreProps {
    states: PagedResultSet<State>;
    selectedState: (stateId: number) => State;
    officeLocation: Office;
}

interface IAdminEditOfficePageDispatchProps {
    navigate: (path: string) => void;
    updateOffice: (office: Office) => void;
    getStates: (options: ODataOptions) => void;
    getOfficeById: (id: number) => void;
}

type IAdminEditOfficePageProps = RouteComponentProps<{ id?: string }> & IAdminEditOfficePageStoreProps & IAdminEditOfficePageDispatchProps;

class AdminEditOfficePage extends React.Component<IAdminEditOfficePageProps> {
    validate = (office: Office) => {
        if (this.props.officeLocation) {
            office.id = this.props.officeLocation.id;
        }

        const errors: AnyObject = {};
        errors.address = {};

        errors.name = 'Name required';
        errors.address.addressLine1 = 'Address Line 1 required';
        errors.address.city = 'City required';
        errors.address.state = 'State required';
        errors.address.zipCode = 'Zipcode required';
        if (office.name !== undefined) {
            errors.name = undefined;
        }
        if (office.address) {
            if (office.address.addressLine1) {
                errors.address.addressLine1 = undefined;
            }
            if (office.address.city) {
                errors.address.city = undefined;
            }
            if (office.address.state) {
                errors.address.state = undefined;
            }
            if (office.address.zipCode) {
                errors.address.zipCode = undefined;
            }
            if (office.address.addressLine1 && office.address.city && office.address.state && office.address.zipCode) {
                errors.address = undefined;
            }
        }
        return errors;
    };

    private onUpdateOffice = (office: Office) => {
        const id = parseInt(this.props.match.params.id, 10);
        office.id = id;
        office.address.state = this.props.selectedState(office.address.state.id);
        this.props.updateOffice(office);
    };

    componentDidMount() {
        this.props.getStates(new ODataOptions().addPaging(1, 100));
        const id = parseInt(this.props.match.params.id, 10);
        this.props.getOfficeById(id);
    }

    public render() {
        const selectedItem = this.props.officeLocation;
        const selectStates = this.props.states?.items?.map((state: State) => new SelectItem(state.id, state.name));

        return (
            <CardSection title="Edit Office">
                <Form onSubmit={this.onUpdateOffice} validate={this.validate} initialValues={selectedItem}>
                    <FormTextBox label="Name" name="name" />
                    <FormTextBox label="Address Line 1" name="address.addressLine1" />
                    <FormTextBox label="Address Line 2" name="address.addressLine2" />
                    <FormRow>
                        <FormTextBox label="City" name="address.city" />
                        <FormSelect label="State" name="address.state.id" items={selectStates} isRequired={true} />
                        <FormTextBox label="Zipcode" name="address.zipCode" />
                    </FormRow>

                    <button className="bp3-button pt-intent-primary" type="submit">
                        Submit
                    </button>
                </Form>
            </CardSection>
        );
    }
}

const mapStateToProps = (state: IRootState): IAdminEditOfficePageStoreProps => {
    return {
        states: selectors.state.states(state),
        selectedState: (usStateId: number) => selectors.state.state(usStateId)(state),
        officeLocation: selectors.office.officeLocation(state),
    };
};

const mapDispatchToProps: IAdminEditOfficePageDispatchProps = {
    navigate: (path: string) => replace(path),
    updateOffice: (office: Office) => actions.office.updateOffice(office),
    getStates: (options: ODataOptions) => actions.state.getStates(options),
    getOfficeById: (id: number) => actions.office.getById(id),
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminEditOfficePage);



// WEBPACK FOOTER //
// ./src/components/admin/sections/AdminEditOfficePage.tsx